import { FlashcardSet } from "./FlashcardSet";
import { FlashcardData } from "./Flashcard";
import { cn } from "@/lib/utils";

interface FlashcardsPageProps {
  contents: { [key: string]: any };
  className?: string;
}

export function FlashcardsPage({ contents, className }: FlashcardsPageProps) {
  const cards = contents.flashcards as FlashcardData[];

  if (!cards || cards.length === 0) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-theme-1">
        No flashcards available.
      </div>
    );
  }

  return (
    <div className={cn("h-full w-full overflow-y-auto pb-10", className)}>
      {/* Interactive card section */}
      <section className="mb-26">
        <FlashcardSet contents={contents} />
      </section>

      <div className="max-w-3xl mx-auto mb-6 px-6">
        <div className="flex items-center gap-3">
          <div className="h-5 w-1 rounded-full bg-brand-gradient" />
          <h2 className="text-lg font-semibold text-theme-0">
            All cards in this set ({cards.length})
          </h2>
        </div>
      </div>

      <section className="max-w-3xl mx-auto px-6">
        <div className="grid gap-3">
          {cards.map((card, i) => (
            <div
              key={i}
              className={cn(
                "rounded-xl border border-theme",
                "bg-theme-0 backdrop-blur shadow-theme",
                "transition",
                "p-4"
              )}
            >
              <div className="flex items-start gap-4">
                {/* Term / Definition */}
                <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Term */}
                  <div className="text-sm text-theme-0 font-semibold">
                    {card.term}
                  </div>

                  {/* Definition */}
                  <div className="text-sm text-theme-1 leading-relaxed">
                    {card.definition}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
